import { BaseComponentOption } from '@/scripts/Components/Utilities/DataProviderBaseComponent';

export default BaseComponentOption.extend({
  props: {
    fetchFn: {
      type: Function,
      required: true,
    },
    transformFn: {
      type: Function,
      default: (x: any): any => x,
    },
    initialData: {
      default: null,
    },
  },

  data() {
    return {
      data: this.initialData,
    };
  },

  methods: {
    fetchData(): any {
      return this.fetchFn()
        .then(this.transformFn)
      ;
    },
  },
});
